var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkActionPhysician(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.769 3.88417C11.941 4.21117 12.114 4.52917 12.278 4.92817C12.613 5.72817 13.022 6.49017 13.231 7.31717C14.011 10.5042 11.461 13.6822 8.29105 13.8002C8.25405 13.8092 8.21805 13.8092 8.18205 13.8092C4.97705 13.7552 2.35205 10.5392 3.14205 7.31717C3.34205 6.49017 3.75905 5.72717 4.07805 4.92717C4.25005 4.51017 4.44105 4.18317 4.61305 3.84717",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 12.434C21.0063 12.7361 20.9524 13.0364 20.8413 13.3173C20.7301 13.5982 20.564 13.8541 20.3527 14.07C20.1414 14.2859 19.8891 14.4575 19.6106 14.5746C19.3321 14.6917 19.0331 14.7521 18.7309 14.7522C18.4288 14.7522 18.1298 14.692 17.8512 14.575C17.5727 14.458 17.3203 14.2865 17.1089 14.0707C16.8975 13.8549 16.7313 13.5991 16.62 13.3182C16.5087 13.0373 16.4547 12.7371 16.4609 12.435C16.4609 11.833 16.7001 11.2556 17.1258 10.8299C17.5515 10.4042 18.1289 10.165 18.7309 10.165C19.333 10.165 19.9104 10.4042 20.3361 10.8299C20.7618 11.2556 21.0009 11.833 21.0009 12.435L20.9999 12.434Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7301 14.7049V14.9309C18.7301 16.3157 18.18 17.6438 17.2008 18.623C16.2215 19.6023 14.8934 20.1524 13.5086 20.1524C12.1238 20.1524 10.7957 19.6023 9.81645 18.623C8.83723 17.6438 8.28711 16.3157 8.28711 14.9309V13.7969",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkActionPhysician);
export default __webpack_public_path__ + "static/media/bulk-action-physician.2ab98a22d7e738bf925b40c4b1c4b345.svg";
export { ForwardRef as ReactComponent };